import { useState } from "react"
import { colors, fonts, glyphs } from "../../Styles"

/* eslint-disable */
export enum ReportShortCut_Type {
  goTo="Go to",
  delete="Delete"
}
/* eslint-enable */

interface ReportShortCut_Props {
  header: string
  amount: number
  onClick?: () => void
  type?: ReportShortCut_Type
}
/**
 * ReportShortCut
 * @param header String to show.
 * @param amount Number to show.
 * @param onClick Function to handle onClick.
 * @returns A clickable component that shows an amount and header.
 */
export default function ReportShortCut({header, amount, onClick, type}:ReportShortCut_Props) {
  const [isHovered, setIsHovered] = useState<boolean>(false)

  let _icon
  switch (type) {
    case ReportShortCut_Type.delete:
      _icon = <glyphs.Delete size="25px"/>
      break;
    case ReportShortCut_Type.goTo:
    default:
      _icon = <glyphs.Arrow size="25px"/>
      break;
  }
  
  return (
    <div
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}  
      onClick={onClick}
      style={{ 
        cursor: isHovered? "pointer" : "default", 
        opacity: isHovered? "0.3" : "1", 
        transition: "0.3s ease", 
        backgroundColor: colors.greyLightTertiary, 
        border: "5px solid "+colors.blueLightPrimary, 
        borderRadius: "10px", 
        height: "50px !important", 
        width: "100%", 
        display: "grid",
        gridTemplateColumns: "45px 1fr 45px",
        gridAutoRows: "1fr",
        boxSizing: "border-box",
        gap: "10px"
      }}
    >  

      <div style={{gridArea: "1/1/2/2", display: "flex", alignItems: "center", justifyContent: "center", borderRight: "2px solid "+colors.greyLightSecondary, margin: "8px 0px"}}>
        <p style={{...fonts.header, ...fonts.fontSize3, color: colors.greyDarkPrimary}}>{amount}</p>
      </div>

      <div style={{gridArea: "1/2/2/3", display: "flex", alignItems: "center", justifyContent: "start", padding: "5px 0" }}>
        <p style={{...fonts.paragraph, ...fonts.fontSize4, color: colors.greyDarkPrimary}}>{header}</p>
      </div>

      <div style={{gridArea: "1/3/2/4", display: "flex", alignItems: "center", justifyContent: "center", backgroundColor: colors.blueLightPrimary, paddingLeft: "5px"}}>
        {_icon}
      </div>

    </div>
  )
}